import { createContext } from "react";

const context = createContext({
  newDownloads: [],
  pendingCount: 0,
  addPendingDownload: () => {},
  completeDownload: () => {},
  discardPendingDownload: () => {},
  acknowledgeDownload: () => {},
  syncDownloads: () => {},
});

export default context;
